const getCartTitle = traveler =>
  traveler
    ? `${I18n.t('components.ibe.search_results.copy_content_title', {
        name: traveler.firstName,
      })}\n\n`
    : '';

export default getCartTitle;
